<div class="cm-contenido-central">
  <div class="toolsField">
    <div class="full-width">
      <mat-form-field appearance="outline" class="full-width">
      <mat-label>Filtrar por palabra en descripción</mat-label>
        <input matInput (keyup)="filtroTexto($event.target.value)" placeholder="Filtrar por palabra en descripción">
      </mat-form-field>
      <!--<mat-form-field>-->
      <!--<mat-select (selectionChange)="checkFiltros($event)" placeholder="Tipo de evento"-->
      <!--multiple>-->
      <!--<ng-container *ngFor="let categoria of categorias">-->
      <!--<mat-option *ngFor="let subcategoria of categoria.categorias" [value]="subcategoria.id">-->
      <!--{{subcategoria.nombre}}-->
      <!--</mat-option>-->
      <!--</ng-container>-->
      <!--</mat-select>-->
      <!--</mat-form-field>-->
    </div>

    <form>
      <mat-table #table [dataSource]="dataSource" matSort (matSortChange)="checkFiltros($event)" class="mat-elevation-z4">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 240px !important; padding-right: 24px;">Título</mat-header-cell>
          <mat-cell *matCellDef="let element;" style="max-width: 240px !important; padding-right: 24px;">
            <mat-checkbox [value]="element.id" [checked]="element.isSelected" (change)="cambiarEstado($event, element)">
              {{element.nombre}}
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="categoria">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 176px !important;">
            <label style="text-align: left">Categoría<br>Subcategoría</label>
          </mat-header-cell>
          <mat-cell *matCellDef="let element;" style="max-width: 176px !important;">
            <!--<pre>{{element.categoria | json}}</pre>-->
            <label>
              <strong>{{element.categoria.agrupador}}</strong>
              <br>
              {{element.categoria.nombre}}
            </label>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="descripcion">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Descripción</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div [innerHTML]="element.resumen"></div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>
      <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20, 50]" [showFirstLastButtons]="true">
      </mat-paginator>
    </form>
  </div>
</div>
<div class="cm-botones" *ngIf="!guardando">
  <button style="margin-right: 4px;" mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()">Guardar</button>
</div>
<div class="cm-botones" *ngIf="guardando">
  <mat-progress-bar mode="query"></mat-progress-bar>
</div>
